import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'

import type { PagedListOfLists, WelcomeMessage } from 'Types/beListApi'

interface getListOfNlListQSParams {
  force?: boolean
  pageSize?: number
  pageNumber?: number
  orderBy?: string
  orderDescending?: boolean
}

const getListOfNlListQSDefaultParams = {
  force: true,
  pageSize: 0,
  pageNumber: 1,
  orderBy: 'Id',
  orderDescending: true,
}

const endpoints = ((baseURL: string) => {
  return {
    //  Lists
    getListOfNlList: (qsParams: getListOfNlListQSParams) =>
      `${baseURL}/api/lists?${encodeParams(qsParams) as string}`,
    getWelcomeMessage: (idList: number) =>
      `${baseURL}/api/list/${idList}/welcome`,
    getListsLazy: (qsParams: getListOfNlListQSParams) =>
      `${baseURL}/api/listslazy?${encodeParams(qsParams) as string}`,
  }
})(process.env.BELIST_URL as string)

export const beListApiGetListOfNlList = async (
  qsParams: getListOfNlListQSParams,
): Promise<PagedListOfLists> => {
  const url = endpoints.getListOfNlList({
    ...getListOfNlListQSDefaultParams,
    ...qsParams,
  })

  return await apiWrapper({
    method: 'get',
    url,
  }).then((res) => res.data)
}

export const beListApiGetWelcomeMessage = async (
  idList: number,
): Promise<WelcomeMessage> => {
  return await apiWrapper({
    method: 'get',
    url: endpoints.getWelcomeMessage(idList),
  }).then((res) => res.data)
}

export const beListGetListsLazy = async (
  params: getListOfNlListQSParams,
): Promise<PagedListOfLists> => {
  const url = endpoints.getListsLazy(params)

  return apiWrapper({
    method: 'get',
    url: url,
  }).then((res) => res.data)
}
